module.exports = __webpack_public_path__ + "static/img/Bachelor_010656.72282c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010656.jpg
// module id = 201
// module chunks = 0